
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card} from 'reactstrap';
import { AiOutlinePlusSquare } from "react-icons/ai";
import { AiOutlineMinusSquare } from "react-icons/ai";
import User from '../user/user';
import BasketDetailsDialogue from './basketDetailsDialogue';

const stateManager = require('../../../../utils/state/stateManager');
const stringUtil = require('../../../../utils/string/stringUtil');
const formatter = require('../../../../utils/formatter/formatter');
const basketUtil = require('../../../../utils/basket/basketUtil');
const guidUtil = require('../../../../utils/guid/guidUtil');
const localizationUtils = require('../../../../utils/localization/localizationUtils');
const constants = require('../../../../utils/domain/constants');
class BasketSummary extends Component 
{
    constructor(props)
    {
        super(props);
        
        this.state = {};
        this.state.id = guidUtil.generateGuid();

        this.state.showUserDetailsDialogue = false;
        this.state.showBasketDetailsDialogue = false;

        this.handleScroll = this.handleScroll.bind(this);
   }

   componentDidMount()
    {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event)
    {
        var basket = document.getElementById(this.state.id);
        var basketOffSetTop = basket.offsetTop;

        if (window.pageYOffset > basketOffSetTop) 
        {
            basket.classList.add("basket");
        } 
        else 
        {
            basket.classList.remove("basket");
        }

    }
    
    render()
    {
        var state = stateManager.getStore().getState();
        if (basketUtil.isBasketEmpty())
        {
            return <div id={this.state.id}>
                        <Card style={{marginTop: '20px', marginLeft: '20px', marginRight: '20px'}}>
                            {this.renderHeader()}
                            <div style={{marginTop:'30px', textAlign:'center', fontSize: '30px'}}>
                                <i className="fa fa-shopping-basket"></i>
                            </div>
                            <div style={{marginTop:'10px', marginBottom: '30px', textAlign:'center'}}>
                                Your <b>{state.basket.order.dispatchType}</b> basket is empty
                            </div>
                            {
                                stateManager.getStore().getState().franchisor.displayResellerBranding
                                ? <div className='smallText' style={{color:`var(--muted-text-color)`, textAlign: 'center', paddingBottom: '5px'}}>Powered by Flipdish</div>
                                : null
                            }
                        </Card>
                    </div>
        }

        return <div id={this.state.id}>
                    <Card style={{marginTop: '20px', marginLeft: '20px', marginRight: '20px'}}>
                        
                        <div style={{overflowY: 'scroll', maxHeight: `75vh`,}}>
                            {this.renderHeader()}
                            <div style={{marginTop:'10px', marginLeft:'15px', marginRight:'15px'}}>
                                
                                <div style={{marginTop:'20px'}}>
                                    <h4 style={{fontWeight:'bold', marginBottom:'0px', textAlign: 'center'}}>{state.basket.order.dispatchType} Basket</h4>
                                </div>
                                <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                                
                                <div>
                                    {this.renderOrders()}
                                </div>

                                <div>
                                    {this.renderPriceWidget()}
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop:'30px', marginBottom:'10px', textAlign:'center'}}>
                                    {this.renderProceedToPaymentButton()}
                        </div>
                        {
                                stateManager.getStore().getState().franchisor.displayResellerBranding
                                ? <div className='smallText' style={{color:`var(--muted-text-color)`, textAlign: 'center', paddingBottom: '5px'}}>Powered by Flipdish</div>
                                : null
                        }
                    </Card>
                    {this.renderUserDetailsDialogue()}
                    {this.renderBasketDetailsDialogue()}
                </div>
    }

    renderHeader()
    {
        var state = stateManager.getStore().getState();
        return  <div className='AppBar'>                    
                    <div  style={{padding: "5px 10px 5px 10px"}}>
                        <div>{state.property.name}</div>
                        <div className='smallText'>{state.property.address}</div>
                    </div>        
                </div>
                    
    }

    renderOrders()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        
        var components = [];

        for (var index = 0; index < basket.order.saleItems.length; index++)
        {
            components.push(this.renderItem(basket.order.saleItems[index]));
        }
        
        return <div style={{marginTop:'30px'}}>
                    {components}
                    <hr style={{marginTop:'10px', marginBottom:'0px'}}/> 
               </div>
    }

    renderItem(saleItem)
    {
        var components = [];

        components.push(
                            <tr>
                                <td style={{width:'5%', whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'left'}}>
                                    {saleItem.quantity}
                                </td>
                                <td style={{fontWeight:'bold', verticalAlign:'middle', textAlign:'left'}}>
                                    <div style={{marginLeft:'8px'}}>{saleItem.caption}</div>
                                </td>
                                <td style={{width:'10%', textAlign:'right'}}>
                                    <div style={{marginLeft:'5px'}}>
                                        <AiOutlinePlusSquare style={{fontSize: `var(--button-change-quantity-size)`, marginRight:'5px'}}
                                                                        onClick={()=>
                                                                        {
                                                                            this.changeQuantity(saleItem, 1);
                                                                        }}/>
                                    </div>
                                </td>
                                <td style={{width:'10%', textAlign:'right'}}>
                                    <div style={{marginRight:'5px'}}>
                                        <AiOutlineMinusSquare style={{fontSize: `var(--button-change-quantity-size)`}}
                                                                            onClick={()=>
                                                                                {
                                                                                    this.changeQuantity(saleItem, -1);
                                                                                }}/>
                                    </div>
                                </td>
                                <td style={{width:'20%', whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'right'}}>
                                    {formatter.convertToCurrencyFormat(saleItem.quantity * saleItem.unitPrice)}
                                </td>
                            </tr>
                        )

        this.renderSubItems(saleItem, components, 8);

        components = <table style={{width:'100%', tableLayout:'fixed'}}>{components}</table>
        return <div style={{marginBottom:'10px'}}>{components}</div>;
    }

    renderSubItems(saleItem, components, margin)
    {
        saleItem.saleItems.forEach(subSaleItem =>
            {
                var priceComponent = <div>&nbsp;</div>
                if (subSaleItem.unitPrice > 0)
                {
                    priceComponent = formatter.convertToCurrencyFormat(subSaleItem.quantity * subSaleItem.unitPrice);
                }
                components.push(
                                    <tr>
                                        <td style={{whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'left'}}>
                                            &nbsp;
                                        </td>
                                        <td style={{verticalAlign:'middle', textAlign:'left'}}>
                                            <div style={{marginLeft:`${margin}px`}}>{stringUtil.trimString(subSaleItem.caption)}</div>
                                        </td>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td style={{whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'right'}}>
                                            {priceComponent}
                                        </td>
                                    </tr>
                                );
                this.renderSubItems(subSaleItem, components, margin+5);
            })
    }

    renderProceedToPaymentButton()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        return <Button color="primary" 
                    style={{
                            color:`var(--button-addToBasket-font-color)`, 
                            background:`var(--button-addToBasket-background-color)`,
                            borderColor:`var(--button-addToBasket-background-color)`,
                            fontSize:`var(--button-addToBasket-font-size)`,
                            fontWeight:'bold',
                            marginRight:'5px',
                            paddingLeft:'20px',
                            paddingRight:'20px',
                            paddingTop:'10px',
                            paddingBottom:'10px',
                            width:'80%',
                            borderRadius:15
                        }}
                onClick={async ()=>
                    {
                        if(stringUtil.areStringSame(state.currentMode, constants.applicationMode.overPhonePayment))
                            this.state.showBasketDetailsDialogue = true;
                        else
                            this.state.showUserDetailsDialogue = true;
                        this.setState({});
                    }}>Proceed To Payment - {formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}</Button>
    }


    renderPriceWidget()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var components = [];
        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Total Order Price
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalOrderPrice())}
                            </td>
                        </tr>);

        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Discount
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalDiscounts())}
                            </td>
                        </tr>);

        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Charges
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalCharges())}
                            </td>
                        </tr>);

        if (!localizationUtils.isVatInclusive() && localizationUtils.isVatApplicable())
        {
            components.push(<tr>
                                <td style={{width:'99%'}}>
                                    {localizationUtils.getVatCaption()}
                                </td>
                                <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                    {formatter.convertToCurrencyFormat(basketUtil.getTotalVat())}
                                </td>
                            </tr>);
        }

        
        components.push(<tr>
            <td style={{width:'99%', fontWeight:'bold'}}>
                Total Sale Price
            </td>
            <td style={{whiteSpace:'nowrap', paddingLeft:'20px', fontWeight:'bold'}}>
                {formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}
            </td>
        </tr>);

        return <div style={{marginTop:'30px'}}>
                    <table style={{width:'100%'}}>
                        {components}
                    </table>
               </div>

        
    }


    changeQuantity(saleItem, changeBy)
    {
        this.addRemoveQuantity(saleItem, changeBy);
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        basket.order.saleItems = basket.order.saleItems.filter(s => s.quantity > 0);
        basketUtil.markBasketForEnrichment();
        this.setState({});
    }

    addRemoveQuantity(saleItem, changeBy)
    {
        saleItem.quantity = saleItem.quantity + changeBy;
        saleItem.saleItems.forEach(subItem =>
            {
                this.addRemoveQuantity(subItem, changeBy);
            });
    }

    renderUserDetailsDialogue()
    {
        if (!this.state.showUserDetailsDialogue)
            return;

        return <User onDismiss={()=>
                    {
                        this.state.showUserDetailsDialogue = false;
                        this.setState({});
                    }}
                    onCompletion={()=>
                    {
                        this.state.showUserDetailsDialogue = false;
                        this.state.showBasketDetailsDialogue = true;
                        this.setState({});
                    }}/>
    }

    renderBasketDetailsDialogue()
    {
        if (!this.state.showBasketDetailsDialogue)
            return null;

        return <BasketDetailsDialogue onDismiss={()=>
                                        {
                                            this.state.showBasketDetailsDialogue = false;
                                            this.setState({});
                                        }}/>
    }

}

const mapStateToProps = state => 
{
    return { 
                basketVersion: state.basketVersion,
            }
}

export default connect(mapStateToProps)(BasketSummary)
